import React from 'react'
import styled from 'styled-components'
import { media } from '../styles/vars'
import ArticleListItem from '../components/ArticleListItem'
import bgImage from '../static/images/backgrounds/article_list.jpg'
import article1 from '../static/images/backgrounds/pic1.jpg'
import article2 from '../static/images/backgrounds/pic2.jpg'
import article3 from '../static/images/backgrounds/pic3.jpg'
import { Title } from '../styles/elements'

const Container = styled.div`
padding:40px 0;
text-align:center;
background-image:url(${bgImage});
background-size:cover;
background-position:center;

${
    media.desktop`
    padding:100px 0;
    `
    }
`

const ItemsContainer = styled.div`
max-width:80%;
margin:20px auto;

${
    media.desktop`
    max-width:initial;
    display:flex;
    justify-content:center;
    `
    }
`
const ArticleListSection = () => {
    return (
        <Container>
            <div>
                <Title>רבותי ההיסטוריה</Title>
            </div>
            <ItemsContainer>
                <ArticleListItem
                    title="מכוניות על מדים"
                    description="בשירות הציבור: המכוניות שהטיסו את שוטרי התנועה בעקבות עברייני המהירות, מקום המדינה ועד היום"
                    articleId="5090566"
                    imageSrc={article1}
                />
                <ArticleListItem
                    title="ניצלו מהדחה"
                    description="הישרדות, המסלול המהיר: המכוניות שהחזיקו מעמד הכי הרבה זמן בשוק הישראלי"
                    articleId="5096587"
                    imageSrc={article2}
                />
                <ArticleListItem
                    title="ועדת קישוט"
                    description="מהמאוורר, דרך עץ הריח ועד כיסא החרוזים: כל השטויות שמילאו לנו את האוטו לפני שהמכונית הפכה למחשב על גלגלים"
                    articleId="5100064"
                    imageSrc={article3}
                />
            </ ItemsContainer>
        </Container>
    )
}

export default ArticleListSection;


// WEBPACK FOOTER //
// ./src/containers/ArticleListSection.jsx